
import events from './event';
const baseUrl = 'https://api.cloud.nuskin.com/url-shortener/v1';

/**
 * This class allows us to Shorten Urls
 * @namespace ShortenUrl
 */
class ShortenURL {

    constructor() {
        this.AP_KY = "68F8D2B3-7C1E-4FDD-B4B2-6A562593B47A";
        this.REQUEST_URL_SHORTEN = `${baseUrl}/create?longUrl={{long_url}}&apiKey=${this.AP_KY}`;
        this.REQUEST_URL_CUSTOM = `${baseUrl}/customize?hash={{hash}}&customHash={{customHash}}&apiKey=${this.AP_KY}`;
        this.requestURLParams = {
            hash: "",
            customHash: null,
            long_url: ""
        };
        this.URLs = {};
        this.currentData = {};
    }

    /**
     *
     * @param {string} key - The new API key to be used.  This will allow you to select a campaign other than the default
     *
     * key: 36 chars
     *
     *  @memberof ShortenUrl
     *
     */
    setAPIKey(key) {
        if (typeof(key) === 'string' && key.length == 36) {
            this.AP_KY = key;
            this.REQUEST_URL_SHORTEN = `${baseUrl}?longUrl={{long_url}}&apiKey=${this.AP_KY}`;
            this.REQUEST_URL_CUSTOM =  `${baseUrl}/customize?hash={{hash}}&customHash={{customHash}}&apiKey=${this.AP_KY}`;
        }
    }

    /**
     *
     * @param {string} originalURL - The URL to be shortened.  If cidparams are present, they will be appended as a cid querystring for po.st analytics
     * @param {function} callback
     * @param [cidparams] - optional analytics params for po.st tracking
     * {{locale: string, channel: string, campaign: string, user: string}}
     *
     * locale: 4 chars eg. ENUS
     * channel: 2 chars eg. FB
     * campaign/sku: 8 chars eg. 01003417
     *
     *  @memberof ShortenUrl
     *
     */
    getShortURL(originalURL, callback, cidparams) {
        let deferred = $.Deferred();
        let keyURL = this.buildLongURL(originalURL, cidparams);
        let storedData = this.getStoredData(keyURL);
        if (storedData.short_url != undefined) {
            this.emitShortURL(storedData, callback);
            deferred.resolve(storedData.short_url);
        } else {
            storedData.callback = callback;
            this.setStoredData(keyURL, storedData);
            let lastCallback = (data) => {
                this.onShortenRequestSuccess(data);
                if (callback) {
                    callback(data);
                }
                deferred.resolve(data.short_url);
            };
            this.sendRequest(this.getShortenRequestURL({long_url: keyURL, custom: null}), lastCallback);
        }

        return deferred.promise();
    }

    sendRequest(serviceURL, success) {
        $.ajax({
            type: "GET",
            url: serviceURL,
            dataType: "json",
            success: success,
            error: this.onRequestError
        });
    }

    getCallback(keyURL) {
        let storedData = this.getStoredData(keyURL);
        return storedData.callback;
    }

    /**
     *
     * @param [data] {{short_url:string, long_url:string}}
     * @param callback
     */
    emitShortURL(data, callback) {
        let emitData = data;
        if (!callback) {
            let cb = this.getCallback(data.long_url);
            if (typeof cb === "function")
                cb(emitData);
            return;
        }
        callback(emitData);
    }

    emitError(error) {
        let errdata = $.extend(true, this.currentData, error);
        events.publish(events.social.SHORTEN_URL_ERROR, errdata);
    }

    setStoredData(keyURL, data) {
        this.currentData = $.extend(true, this.getStoredData(keyURL), data);
        this.currentData.long_url = keyURL;
        this.URLs[keyURL] = this.currentData;
    }

    /**
     *
     * @param keyURL
     * @returns {{}}
     */
    getStoredData(keyURL) {
        return this.URLs[keyURL] ? this.URLs[keyURL] : {};
    }

    onShortenRequestSuccess(responseData) {
        if (responseData.status_txt) {
            if (this.isRequestOK(responseData)) {
                this.setStoredData(responseData.long_url, responseData);
                if (!this.requestURLParams.customHash) {
                    this.emitShortURL(responseData);
                }
                else {
                    this.sendRequest(this.getCustomizeRequestURL(), this.onCustomRequestSuccess);
                }
            }
            else {
                this.emitError(responseData);
            }
        }
    }

    onCustomRequestSuccess(responseData) {
        if (this.isRequestOK(responseData)) {
            this.short_url = this.short_url.replace(this.requestURLParams.hash, this.requestURLParams.customHash);
        }
        this.emitShortURL();
    }

    onRequestError(data) {
        this.emitError(data);
    }


    // --- UTIL FUNCTIONS

    isRequestOK(data) {
        let txt = data.status_txt;

        //TODO: for customize functionality, if ALREADY EXIST, check to make sure the expand URL is identical using...
        // http://po.st/api/expand

        return (
            txt != "INVALID_URL" ||
            txt === "OK" ||
            txt === "ALREADY_EXIST"
        );
    }


    /**
     *
     * @param {{long_url: string, custom: string}} [requestData]
     * @returns {*}
     */
    getShortenRequestURL(requestData) {
        this.requestURLParams.customHash = requestData.custom;
        this.requestURLParams.long_url = encodeURIComponent(requestData.long_url);
        return this.parseRequestURL(this.REQUEST_URL_SHORTEN, ["long_url"]);
    }

    getCustomizeRequestURL() {
        return this.parseRequestURL(this.REQUEST_URL_CUSTOM, ["hash", "customHash"]);
    }

    parseRequestURL(requestURL, props) {
        $.each(props, (index, item) => {
            requestURL = requestURL.replace("{{" + item + "}}", this.requestURLParams[item]);
        });
        return requestURL;
    }

    /**
     *
     * @param url {string}
     * @param [cidparams] - optional analytics params for po.st tracking
     * {{locale: string, channel: string, campaign: string}}
     */
    buildLongURL(url, cidparams) {
        return this.addParams(url, cidparams);
    }


    /**
     *
     * @param url {string}
     * @param [cidparams] - optional analytics params for po.st tracking
     * {{locale: string, channel: string, campaign: string}}
     * @returns {string}
     */
    addParams(url, cidparams) {
        if (!cidparams) {
            return url;
        }
        let paramObj = this.getCID(cidparams),
            addParam = aem.util.Url.addParam;
        if (aem.nuskin.configuration.socialMedia.enableSponsorShare && aem.nuskin.account.AccountManager.isLoggedIn() != null) {
            paramObj.gwpId = user.id;
        }

        for (let key in paramObj) {
            if (paramObj.hasOwnProperty(key)) {
                url = addParam(url, key, paramObj[key]);
            }
        }
        return url;
    }

    /**
     * QUERYSTRING FORMAT:
     * (char counts)
     * locale: 4 => ENUS
     * channel: 2 => FB
     * campaign/sku: 8 => 01003417 or pageType-based?
     * SAP_ID: 9-10 =>
     *
     *                   |   | |       |         |
     * e.g PRODUCT PAGE: ENUSFB01003417US00320640
     *              ?cid=ENUSFB01003417NOUSERDATA
     *
     *
     * @returns {{cid: string}}
     * @param [cidparams] {{locale: string, channel: string, campaign: string}}
     */
    getCID(cidparams) {
        return {
            cid: this.formatLocale(cidparams.locale) +
            this.formatChannel(cidparams.channel) +
            this.formatCampaign(cidparams.campaign) +
            this.getUserID(cidparams.user)
        };
    }

    /**
     * format to 4char uppercase, no '_', eg. "ENUS"
     * @param locale
     * @returns {string}
     */
    formatLocale(locale) {
        return (locale && locale.length >= 4) ? locale.toUpperCase().replace("_", "").substr(0, 4) : "ENUS";
    }

    /**
     * format to two chars, uppercase, eg. "FB"
     * @param channel
     * @returns {string}
     */
    formatChannel(channel) {
        return (channel && channel.length >= 2) ? channel.toUpperCase().substr(0, 2) : "NA";
    }

    /**
     * campaign/sku:8 => 01003417 or pageType-based
     * @param campaign
     * @returns {string}
     */
    formatCampaign(campaign) {
        return (campaign && campaign.length >= 8) ? campaign.toUpperCase().substr(0, 8) : "_DEFAULT";
    }

    /**
     * SAP_ID:9-10 chars
     * @returns {string}
     */
    getUserID(user) {
        let user_id = user || "NOUSERDATA";
        if (aem.account && aem.account.AccountManager && aem.account.AccountManager.currentData) {
            user_id = aem.account.AccountManager.currentData.id;
        }
        return user_id;
    }
}

export default new ShortenURL();
